<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/departmentList' }">部门</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="insert">新增</el-button>
                    <el-button size="small" plain @click="copy">复制</el-button>
                    <el-button size="small" plain @click="update">编辑</el-button>
                    <el-button size="small" plain @click="del">删除</el-button>
                    <draggableDetail :draggable="{ data_name: 'department' }" @isErrshow="reload"></draggableDetail>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="data" class="details" label-width="auto">
                        <template>
                            <el-row v-for="(item_out, index_out) in colData" :key="index_out">
                                <el-col :span="12" v-for="(item, index) in item_out" :key="index">
                                    <el-form-item :label="item.title ? item.title + '：' : ''">
                                        <div
                                            class="read_only read_only_link"
                                            v-if="
                                                in_array(item.prop, [
                                                    'principal_hierarchy',
                                                    'parent',
                                                    'principal',
                                                    'department_one',
                                                    'department_two'
                                                ])
                                            "
                                        >
                                            <span @click="toDetail(item.prop)">{{ data[item.prop] }}</span>
                                        </div>
                                        <el-input
                                            v-else
                                            v-model="data[item.prop]"
                                            class="flex_item_text"
                                            size="mini"
                                            readonly="readonly"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </template>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="职位列表" name="2">
                    <vHierarchyList v-if="flag" :postList="hierarchy_params"></vHierarchyList>
                </el-collapse-item>
                <el-collapse-item disabled title="任职记录" name="3">
                    <vHierarchyPersonList v-if="flag" :postList="hierarchy_person_params"></vHierarchyPersonList>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { onDelete, in_array, processColumnDataToRowNew } from '@/js/common';
import vHierarchyList from '../../listComponent/jurisdiction/hierarchyListComponent.vue';
import vHierarchyPersonList from '../../listComponent/jurisdiction/hierarchyPersonListComponent.vue';
import draggableDetail from '../../../common/DrawerDetail.vue';
export default {
    inject: ['reload'],
    name: 'departmentDetail',
    components: {
        vHierarchyList,
        vHierarchyPersonList,
        draggableDetail
    },
    data() {
        return {
            colData: [],
            activeNames: ['1', '2', '3'],
            data: {},
            queryParams: {},
            headerTitle: '部门详情',
            flag: false,
            hierarchy_params: {},
            hierarchy_person_params: {}
        };
    },
    watch: {
        $route(to, from) {
            this.queryParams.rid = to.query.id;
            this.reload();
        }
    },
    beforeMount() {
        this.selectedColData(); //筛选列
        this.initQueryParams();
    },
    mounted() {
        this.initSubListParams();
        this.$nextTick(() => {
            this.getData(); //获取详情
            this.flag = true;
        });
    },
    methods: {
        in_array,
        initSubListParams() {
            // 职位列表
            this.hierarchy_params.params = {
                department_rid: this.queryParams.rid
            };
            this.hierarchy_params.headerTitle = false;
            this.hierarchy_params.code = true;
            this.hierarchy_params.name = true;
            this.hierarchy_params.status = true;
            this.hierarchy_params.rank = true;
            this.hierarchy_params.superior_rid = true;
            this.hierarchy_params.team_role = true;
            this.hierarchy_params.addBtn = true;
            this.hierarchy_params.searchBtn = true;
            this.hierarchy_params.resetBtn = true;
            this.hierarchy_params.downFileBtn = true;
            this.hierarchy_params.setBtn = true;
            // 任职记录
            this.hierarchy_person_params.params = {
                department_rid: this.queryParams.rid
            };
            this.hierarchy_person_params.headerTitle = false;
            this.hierarchy_person_params.code = true;
            this.hierarchy_person_params.status = true;
            this.hierarchy_person_params.person_rid = true;
            this.hierarchy_person_params.concentration = true;
            this.hierarchy_person_params.start_date_range = true;
            this.hierarchy_person_params.addBtn = true;
            this.hierarchy_person_params.searchBtn = true;
            this.hierarchy_person_params.resetBtn = true;
            this.hierarchy_person_params.downFileBtn = true;
            this.hierarchy_person_params.setBtn = true;
        },
        toDetail(prop) {
            if (prop == 'principal_hierarchy' && this.data.principal_hierarchy_rid) {
                this.$router.push({
                    path: '/hierarchyDetail',
                    query: {
                        id: this.data.principal_hierarchy_rid
                    }
                });
            } else if (prop == 'parent' && this.data.parent_rid) {
                this.$router.push({
                    path: '/departmentDetails',
                    query: {
                        id: this.data.parent_rid
                    }
                });
            } else if (prop == 'principal' && this.data.principal_rid) {
                this.$router.push({
                    path: '/personDetail',
                    query: {
                        id: this.data.principal_rid
                    }
                });
            } else if (prop == 'department_one' && this.data.A_rank_department_rid) {
                this.$router.push({
                    path: '/departmentDetails',
                    query: {
                        id: this.data.A_rank_department_rid
                    }
                });
            } else if (prop == 'department_two' && this.data.B_rank_department_rid) {
                this.$router.push({
                    path: '/departmentDetails',
                    query: {
                        id: this.data.B_rank_department_rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        //筛选列
        selectedColData() {
            let colData = JSON.parse(localStorage.getItem('detailList')).department;
            processColumnDataToRowNew(colData, this);
        },
        //删除
        del() {
            onDelete(this.data.id, this, 'departmentDelete', this.data.name, 'departmentList');
        },
        //编辑
        update() {
            this.$router.push({
                path: 'departmentEdit',
                query: {
                    type: 'update',
                    id: this.data.rid
                }
            });
        },
        //新增
        insert() {
            this.$router.push({
                path: 'departmentEdit',
                query: {
                    type: 'insert'
                }
            });
        },
        //复制
        copy() {
            this.$router.push({
                path: 'departmentEdit',
                query: {
                    type: 'copy',
                    id: this.data.rid
                }
            });
        },
        //详情
        getData() {
            this.$api
                .departmentDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    document.title = this.headerTitle + ':' + res.data.code;
                })
                .catch((error) => {});
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>